(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fabric-index"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mergeRemainingPatterns = async (root) => {
      const grid = root.querySelector('.cd-collection-grid');
      let nextLink = root.querySelector('[data-cd-fabric-next]');
      if (!grid || !nextLink) return;

      const seen = new Set(
        Array.from(grid.querySelectorAll('[data-cd-fabric-card]'))
          .map((card) => card.dataset.cdFabricHandle)
      );

      while (nextLink) {
        const nextUrl = new URL(nextLink.href, window.location.origin);
        nextUrl.searchParams.set('section_id', root.dataset.cdSectionId);

        try {
          const response = await fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          if (!response.ok) break;

          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const nextRoot = documentFragment.querySelector('[data-cd-fabric-index]');
          if (!nextRoot) break;

          nextRoot.querySelectorAll('[data-cd-fabric-card]').forEach((card) => {
            const handle = card.dataset.cdFabricHandle;
            if (!handle || seen.has(handle)) return;
            seen.add(handle);
            grid.append(card);
          });

          nextLink = nextRoot.querySelector('[data-cd-fabric-next]');
        } catch (_error) {
          break;
        }
      }

      Array.from(grid.querySelectorAll('[data-cd-fabric-card]'))
        .sort((left, right) => left.dataset.cdFabricName.localeCompare(right.dataset.cdFabricName))
        .forEach((card) => grid.append(card));
    };

    document.querySelectorAll('[data-cd-fabric-index]').forEach(mergeRemainingPatterns);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-collections"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-cd-related-collections]').forEach((section) => {
      const fabricHandle = new URL(window.location.href).searchParams.get('cd_fabric');
      const excludedHandle = fabricHandle
        ? `fabric-${fabricHandle}`
        : section.dataset.cdCurrentCollectionHandle;

      section.querySelectorAll('[data-cd-related-collection-handle]').forEach((card) => {
        if (card.dataset.cdRelatedCollectionHandle === excludedHandle) card.remove();
      });

      const grid = section.querySelector('.cd-collection-grid');
      if (grid && grid.children.length === 0) section.hidden = true;
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
